export default "__VITE_ASSET__CvJKDIgX__"